import { useImperativeHandle, forwardRef, useState, useEffect } from "react";
import "./ClientContactCard.scss";
import { useNavigate } from "react-router-dom";
import { parseArrayField } from "../../lib/allPurposeFunctions";
import { ColoniesProvider } from './../../context/ColoniesContext';

const ClientContactCard = forwardRef(
  ({ clientcontact, clientid, mode = "navigate", onClick, showCheckbox = false }, ref) => {
    const navigate = useNavigate();

    // console.log("received Client Contact: ",clientcontact)

    // 👇 Local state for isSelected
    const [isSelected, setIsSelected] = useState(clientcontact.isSelected || false);

    // Sync prop with state if clientcontact changes
    useEffect(() => {
      setIsSelected(clientcontact.isSelected || false);
    }, [clientcontact]);

    // 👇 Expose getContact() to parent, includes isSelected
    useImperativeHandle(ref, () => ({
      getContact: () => ({ ...clientcontact, isSelected }),
    }));

    // clientcontact.contactcolonies = parseArrayField(clientcontact.contactcolonies);
    // clientcontact.contacttypes = parseArrayField(clientcontact.contacttypes);  
    // clientcontact.contactnumbers = parseArrayField(clientcontact.contactnumbers);
    // clientcontact.contactemails = parseArrayField(clientcontact.contactemails);


    // console.log("clientcontact Coonies",clientcontact.contactcolonies)
    const formattedcolonies = clientcontact.contactcolonies
      ? JSON.parse(clientcontact.contactcolonies).map((c) => c.colony).join(", ")
      : "";

    const formattedcontacttypes = clientcontact.contacttypes
      ? JSON.parse(clientcontact.contacttypes).map((c) => c.type).join(", ")
      : "";
    


    const formattedNumbers = clientcontact.contactnumbers
      ? JSON.parse(clientcontact.contactnumbers).map((c) => c.number).join(", ")
      : "";

    const formattedEmails = clientcontact.contactemails
      ? JSON.parse(clientcontact.contactemails).map((c) => c.email).join(", ")
      : "";



    // ✅ Handle card click
    const handleCardClick = () => {
      // Only navigate if mode is navigate
      if (mode === "navigate") {
        navigate("/dashboard/savecontact", {
          state: {
            mode: 1,
            clientid,
            clientcontactid: clientcontact.id,
            clientcontact,
          },
        });
      }

      if (onClick) {
        onClick({ ...clientcontact, isSelected });
      }
    };

    // ✅ Handle checkbox change
    const handleCheckboxChange = (e) => {
      e.stopPropagation(); // prevent triggering card click
      setIsSelected(e.target.checked);

      // Update clientcontact object directly too if needed
      clientcontact.isSelected = e.target.checked;
    };

    return (
      <div className="clientContactCard" onClick={handleCardClick}>
        {showCheckbox && (
          <input
            type="checkbox"
            checked={isSelected}
            onChange={handleCheckboxChange}
            className="contactCheckbox"
          />
        )}

        {/* {console.log("clientcontact",clientcontact)} */}
        <h3>{clientcontact.contactname}</h3>
        <p>
          <strong>Type:</strong> {formattedcontacttypes}
        </p>
        <p>
          <strong>Colony Interests:</strong> {formattedcolonies}
        </p>
        <p>
          <strong>Contact Numbers:</strong> {formattedNumbers}
        </p>
        <p>
          <strong>Contact Emails:</strong> {formattedEmails}
        </p>
      </div>
    );
  }
);

export default ClientContactCard;
